/**
 * Screening Modal
 */
document.addEventListener('DOMContentLoaded', () => {
	function reInit() {
		let video      = document.querySelector('.js-screening-video');
		const checkbox = document.querySelector('.js-screening-checkbox');
		const button   = document.querySelector('.js-screening-confirm');
		const help     = document.querySelector('.js-screening-help');

		if ((!video || !checkbox) && !button) {
			return;
		}

		let timerIntervalId = null;
		let videoHasEnded   = false;
		let player          = null;

		if (video) {
			const completed = video.dataset.completed;
			player          = new playerjs.Player(video);

			if (completed === 'false') {
				videoHasEnded = true;
			}

			player.on('ended', function() {
				clearInterval(timerIntervalId);
				videoHasEnded = true;
				updateButtonState();
			});

			player.on('play', function() {
				clearInterval(timerIntervalId);

				timerIntervalId = setInterval(() => {
					player.getDuration(duration => {
						player.getCurrentTime(currentTime => {
							const remainingTime = Math.floor(duration - currentTime);

							if (remainingTime <= 0) {
								clearInterval(timerIntervalId);
								videoHasEnded = true;
								updateButtonState();
							} else {
								help.textContent = `You can access contact details in ${remainingTime} seconds.`;
							}
						});
					});
				}, 1000);
			});

			player.on('pause', function() {
				clearInterval(timerIntervalId);
			});
		} else {
			videoHasEnded = true;
		}

		if (checkbox) {
			checkbox.addEventListener('click', updateButtonState);
		}

		button.addEventListener('click', function() {
			if (!this.disabled) {
				const attribute = this.dataset.attribute;
				const url       = atob(attribute);

				fetch(url)
					.then(response => response.json())
					.then(data => {
						const modal = document.getElementById('policy-modal');

						if (player) {
							clearInterval(timerIntervalId);
							player = null;
						}

						if (modal) {
							modal.innerHTML = data.html;
						}

						window.myModal.setContent(data.html);
					});
			}
		});

		function updateButtonState() {
			const videoRequirementMet    = !video || videoHasEnded;
			const checkboxRequirementMet = !checkbox || checkbox.checked;

			if (videoRequirementMet && checkboxRequirementMet) {
				button.disabled = false;

				if (help) {
					help.textContent = '';
				}
			} else {
				button.disabled = true;

				if (help) {
					if (!videoRequirementMet) {
						help.textContent = 'Please play the video to continue.';
					} else if (!checkboxRequirementMet) {
						help.textContent = 'Please check the box to confirm you agree with the rules.';
					}
				}
			}
		}

		updateButtonState();
	}

	const policyModal = document.querySelectorAll('.js-policy-button');

	policyModal.forEach(button => {
		button.addEventListener('click', function() {
			window.myModal.openModal('#policy-modal');
			reInit();
		});
	});
});
